<ng-container *ngIf="user$ | async as user; else signedOutHeader">
  <tds-header class="desktop-header">
    <tds-header-title>
      <a class="tds-header-link" routerLink="/">CONVERSION</a>
    </tds-header-title>

    <tds-header-dropdown
      slot="end"
      class="goto-dropdown"
      name="goto-dropdown"
      label="Gå till"
      tds-aria-label="Gå till annan Conversion-applikation"
    >
      <tds-header-dropdown-list size="lg">
        <tds-header-dropdown-list-item *ngFor="let link of navigationLinks">
          <a [href]="link.url" target="_blank" rel="noopener noreferrer"
            [attr.aria-label]="link.label + ' (öppnas i ny flik)'">{{ link.label }}</a>
        </tds-header-dropdown-list-item>
      </tds-header-dropdown-list>
    </tds-header-dropdown>

    <tds-header-dropdown slot="end" name="header-dropdown" no-dropdown-icon
      [attr.tds-aria-label]="'Användarmeny för ' + user.name">
      <div slot="label">
        <label>{{ getInitials(user.name) }}</label>
      </div>
      <tds-header-dropdown-list size="lg">
        <tds-header-dropdown-list-user [header]="user.name"></tds-header-dropdown-list-user>
        <tds-header-dropdown-list-item>
          <a routerLink="/">Home</a>
        </tds-header-dropdown-list-item>
        <tds-header-dropdown-list-item>
          <a routerLink="/signout">Sign out</a>
        </tds-header-dropdown-list-item>
      </tds-header-dropdown-list>
    </tds-header-dropdown>

    <tds-header-brand-symbol slot="end">
      <a aria-label="Scania - red gryphon on blue shield" routerLink="/"></a>
    </tds-header-brand-symbol>
  </tds-header>

  <tds-header class="mobile-header">
    <tds-header-dropdown name="header-dropdown" no-dropdown-icon tds-aria-label="Meny">
      <div slot="label">
        <tds-icon name="kebab" size="32px"></tds-icon>
      </div>
      <tds-header-dropdown-list size="sm">
        <tds-header-dropdown-list-user [header]="user.name"></tds-header-dropdown-list-user>
        <tds-header-dropdown-list-item>
          <a routerLink="/">Home</a>
        </tds-header-dropdown-list-item>
        <tds-header-dropdown-list-item *ngFor="let link of navigationLinks">
          <a [href]="link.url" target="_blank" rel="noopener noreferrer"
            [attr.aria-label]="'Gå till ' + link.label + ' (öppnas i ny flik)'">Gå till {{ link.label }}</a>
        </tds-header-dropdown-list-item>
        <tds-header-dropdown-list-item>
          <a routerLink="/signout">Sign out</a>
        </tds-header-dropdown-list-item>
      </tds-header-dropdown-list>
    </tds-header-dropdown>
  </tds-header>
</ng-container>

<ng-template #signedOutHeader>
  <tds-header>
    <tds-header-title>
      <a class="tds-header-link" routerLink="/">CONVERSION</a>
    </tds-header-title>

    <tds-header-brand-symbol slot="end">
      <a aria-label="Scania - red gryphon on blue shield" routerLink="/"></a>
    </tds-header-brand-symbol>
  </tds-header>
</ng-template>

<div class="loading-overlay" *ngIf="loading$ | async" role="status" aria-label="Loading">
  <tds-spinner size="lg" variant="standard"></tds-spinner>
</div>

<div class="container-fluid" *ngIf="error$ | async as message">
  <conversion-alert [type]="'alert-warning'" [message]="message" (close)="dismissError()"></conversion-alert>
</div>

<router-outlet></router-outlet>
